import { labeled } from '../../util/joi';
import { schema as commissionsSchema } from './HomeLoanCommission.schema';
import { schema as compareProductsSchema } from './HomeLoanCompareProducts.schema';
// import { schema as complianceSchema } from './HomeLoanCompliance.schema';
import { schema as fundingWorksheetsSchema } from './HomeLoanFundingWorksheets.schema';
import { schema as reviewProductsSchema } from './HomeLoanReviewProducts.schema';
import { schema as securityDetailsSchema } from './HomeLoanSecurityDetails.schema';

export const homeLoanSchema = (Joi: any, label: string) =>
  Joi.object().keys({
    commission: commissionsSchema(Joi, labeled(label, 'Commissions -')),
    // compliance: complianceSchema(Joi, labeled(label, 'Compliance comments and documents -')),
    compareProducts: compareProductsSchema(Joi, labeled(label, 'Compare loan products -')),
    fundingWorksheets: fundingWorksheetsSchema(Joi, labeled(label, 'Funding worksheets -')),
    reviewProducts: reviewProductsSchema(Joi, labeled(label, 'Review loan products -')),
    securityDetails: securityDetailsSchema(Joi, labeled(label, 'Security details -'))
  });

export default {
  homeLoanSchema
};
